module.exports = __webpack_public_path__ + "static/media/supplier-list-place-holder.253f97fe.svg";